import ReviewsItem from './ReviewsItem';

export default ReviewsItem;
